
import { Question } from '../types';

export const qur101TafsirQuestions: Question[] = [
  {
    id: 'qur111',
    text: 'What are the primary subjects addressed in the Qur\'ān?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Belief (Aqīdah)', isCorrect: true },
      { id: 'b', text: 'Stories of prophets and past nations', isCorrect: true },
      { id: 'c', text: 'Rules and legislation', isCorrect: true },
      { id: 'd', text: 'Ethics and morality', isCorrect: true },
      { id: 'e', text: 'Detailed scientific explanations', isCorrect: false }
    ],
    explanation: 'The primary subjects addressed in the Qur\'ān include: Belief (Aqīdah), including concepts of Tawhīd, Risālah (Prophethood), and the Afterlife; stories of prophets and past nations; rules and legislation for individual and communal life; and ethics and morality for personal development. The Qur\'ān references natural phenomena but doesn\'t provide detailed scientific explanations in the modern sense.',
    topic: 'qur101'
  },
  {
    id: 'qur112',
    text: 'How does the Qur\'ān present the concept of Tawḥīd (Oneness of Allāh)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'By discussing His Signs and Lordship', isCorrect: true },
      { id: 'b', text: 'By explicitly stating His Oneness', isCorrect: true },
      { id: 'c', text: 'By mentioning His beautiful names', isCorrect: true },
      { id: 'd', text: 'By comparing Him to other deities', isCorrect: false }
    ],
    explanation: 'The Qur\'ān presents the concept of Tawḥīd (Oneness of Allāh) in multiple ways: by discussing His Signs and Lordship (as in Sūrat ar-Raʿd); by explicitly stating His Oneness (as in Sūrat al-Ikhlāṣ); and by mentioning His beautiful names (Al-Asmā\' ul-Ḥusnā). Allāh presents these concepts in various ways to resonate with different people, recognizing that people are affected differently by different approaches.',
    topic: 'qur101'
  },
  {
    id: 'qur113',
    text: 'What rhetorical and logical devices does the Qur\'ān use to convey its message?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Parables and analogies', isCorrect: true },
      { id: 'b', text: 'Logical arguments and reasoning', isCorrect: true },
      { id: 'c', text: 'Proximal hypotheses (qiyās iqtirānī)', isCorrect: true },
      { id: 'd', text: 'Scientific proofs using modern terminology', isCorrect: false }
    ],
    explanation: 'The Qur\'ān uses various rhetorical and logical devices to convey its message, including: parables and analogies (like comparing a dead land brought to life by rain to resurrection); logical arguments and reasoning to establish truths; and proximal hypotheses (qiyās iqtirānī), which draw logical conclusions from premises. These diverse approaches help make the message accessible to different minds and personalities.',
    topic: 'qur101'
  },
  {
    id: 'qur114',
    text: 'What does the term "tafsīr" mean linguistically?',
    type: 'single',
    options: [
      { id: 'a', text: 'To untie or uncover something', isCorrect: true },
      { id: 'b', text: 'To explain or illustrate', isCorrect: false },
      { id: 'c', text: 'To translate or convert', isCorrect: false },
      { id: 'd', text: 'To memorize or preserve', isCorrect: false }
    ],
    explanation: 'Linguistically, "tafsīr" means "to untie or uncover something." It comes from the root ف س ر (fa-sa-ra), which carries the meaning of revealing something that was hidden or obscured, like untying a knot to reveal what was inside.',
    topic: 'qur101'
  },
  {
    id: 'qur115',
    text: 'What is the technical definition of tafsīr?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The science and methodology of interpreting the Qur\'ān', isCorrect: true },
      { id: 'b', text: 'A process requiring careful qualification', isCorrect: true },
      { id: 'c', text: 'An activity that must rely on proper sources', isCorrect: true },
      { id: 'd', text: 'Any personal reflection on the meaning of verses', isCorrect: false }
    ],
    explanation: 'Technically, tafsīr is the science and methodology of interpreting the Qur\'ān. It is a careful process requiring proper qualification and reliance on established sources. It is not a light task, and those engaging in it must be cautious to avoid misguiding others or making blasphemous statements. It is much more structured and rigorous than simple personal reflection.',
    topic: 'qur101'
  },
  {
    id: 'qur116',
    text: 'What are the primary sources of tafsīr in order of importance?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Tafsīr of the Qur\'ān by the Qur\'ān itself', isCorrect: true },
      { id: 'b', text: 'Tafsīr by the Sunnah/Hadith', isCorrect: true },
      { id: 'c', text: 'Tafsīr by the statements of the Companions', isCorrect: true },
      { id: 'd', text: 'Tafsīr by the statements of the Tābi\'īn (Successors)', isCorrect: true },
      { id: 'e', text: 'Tafsīr by the Arabic language', isCorrect: true },
      { id: 'f', text: 'Tafsīr by modern scientific discoveries', isCorrect: false }
    ],
    explanation: 'The primary sources of tafsīr in order of importance are: (1) Tafsīr of the Qur\'ān by the Qur\'ān itself, (2) Tafsīr by the Sunnah/Hadith, (3) Tafsīr by the statements of the Companions, (4) Tafsīr by the statements of the Tābi\'īn (Successors), and (5) Tafsīr by the Arabic language. Personal interpretation (ta\'wīl) is secondary and comes after all these sources have been considered.',
    topic: 'qur101'
  },
  {
    id: 'qur117',
    text: 'How does the Qur\'ān explain itself (tafsīr of the Qur\'ān by the Qur\'ān)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'A verse in one place answers a question raised in another', isCorrect: true },
      { id: 'b', text: 'What is summarized in one place is detailed elsewhere', isCorrect: true },
      { id: 'c', text: 'An ambiguous verse is clarified by an explicit one', isCorrect: true },
      { id: 'd', text: 'Each surah contains its own complete explanation', isCorrect: false }
    ],
    explanation: 'The Qur\'ān explains itself in various ways: a verse in one place answers a question raised in another (like Sūrat al-Fātiḥah asking about those who are blessed, and Sūrat al-Nisā\' identifying them); what is summarized in one place is detailed elsewhere; and ambiguous verses (mutashābihāt) are clarified by explicit ones (muḥkamāt). This interconnectedness creates a cohesive whole where parts illuminate each other.',
    topic: 'qur101'
  },
  {
    id: 'qur118',
    text: 'Why is the Sunnah essential for tafsīr of the Qur\'ān?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The Prophet ﷺ was tasked with explaining the Qur\'ān', isCorrect: true },
      { id: 'b', text: 'Some verses can only be understood through the Prophet\'s ﷺ explanations', isCorrect: true },
      { id: 'c', text: 'The Prophet\'s ﷺ actions demonstrate the application of Qur\'ānic guidance', isCorrect: true },
      { id: 'd', text: 'The Sunnah completely replaces the need for other sources', isCorrect: false }
    ],
    explanation: 'The Sunnah is essential for tafsīr because: the Prophet ﷺ was explicitly tasked with explaining the Qur\'ān to people; some verses can only be properly understood through his explanations (like the meaning of "ẓulm" in 6:82, which he clarified refers to shirk); and his actions demonstrated the practical application of Qur\'ānic guidance. The Sunnah complements the Qur\'ān but doesn\'t replace the need for other sources of tafsīr.',
    topic: 'qur101'
  },
  {
    id: 'qur119',
    text: 'Why are the statements of the Companions valuable for tafsīr?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'They witnessed the revelation and its circumstances', isCorrect: true },
      { id: 'b', text: 'They understood the Arabic language and culture of the time', isCorrect: true },
      { id: 'c', text: 'They learned directly from the Prophet ﷺ', isCorrect: true },
      { id: 'd', text: 'Their interpretations are considered infallible', isCorrect: false }
    ],
    explanation: 'The statements of the Companions are valuable for tafsīr because: they witnessed the revelation and its circumstances firsthand; they understood the Arabic language and culture of the time without later influences; and they learned directly from the Prophet ﷺ. While highly authoritative, their interpretations are not considered infallible, but they represent the closest link to the Prophet\'s ﷺ understanding after the Sunnah itself.',
    topic: 'qur101'
  },
  {
    id: 'qur120',
    text: 'Why is tafsīr by the Arabic language considered more limited than other sources?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The language is limited, but the Qur\'ān is not', isCorrect: true },
      { id: 'b', text: 'Linguistic analysis alone can miss contextual factors', isCorrect: true },
      { id: 'c', text: 'The Qur\'ān sometimes uses words in specialized meanings', isCorrect: true },
      { id: 'd', text: 'Arabic was a poorly developed language at the time', isCorrect: false }
    ],
    explanation: 'Tafsīr by the Arabic language is considered more limited because: the language itself is limited, while the Qur\'ān\'s meanings are not; linguistic analysis alone can miss important contextual factors; and the Qur\'ān sometimes uses words in specialized meanings beyond their common usage. This doesn\'t mean Arabic was underdeveloped (it was highly sophisticated), but rather acknowledges that divine speech transcends the full capacity of any human language.',
    topic: 'qur101'
  }
];
